import Accordion from "react-bootstrap/Accordion";
import { FiChevronDown } from "react-icons/fi";
import Form from "react-bootstrap/Form";
import React, { useState, useEffect } from "react";
import InputRange from "react-input-range";
import useAxios from "services/useAxios.tsx";
import { addCommas } from "@persian-tools/persian-tools";

const FilterCart = ({
  resetFilters,
  options,
  handleClickCheckInput,
  availableProduct,
  setAvailableProduct,
  hasDiscountedProduct,
  setHasDiscountedProduct,
  submitFilters,
  priceValue,
  setPriceValue,
  minPriceValue,
  maxPriceValue,
  brands,
}) => {
  return (
    <div className="col-2">
      <div className="mobile-accessories-filter">
        <div className="mobile-accessories-filter-title mb-4">
          <span>فیلترها</span>
          <span
            onClick={resetFilters}
            style={{
              fontSize: "14px",
              color: "#ef394e",
              cursor: "pointer",
            }}
          >
            حذف فیلترها
          </span>
        </div>
        {/* <div className="filter_accordion-box mb-4"> */}
        {/* <Accordion className="filter_accordion">
            <Accordion.Item eventKey="1">
              <Accordion.Header className="filter_accordion-title">
                <div className="filter_acc-tit">
                  <span>برندها</span>
                  <FiChevronDown
                    size={20}
                    color="#3f4064"
                    className="filter_acc-icon"
                  />
                </div>
              </Accordion.Header>
              <Accordion.Body className="px-0">
                <div className="filter_acc-body">
                  <div
                    className="filter_content-acc border-bottom "
                    style={{ height: 200, overflowY: "auto" }}
                  >
                    {brands?.map((feature) => {
                      return (
                        <div
                          className="filter_content-acc py-1"
                          style={{ fontSize: "initial" }}
                          key={feature?.id}
                        >
                          <input
                            type="checkbox"
                            id={feature?.id}
                            name={feature?.name}
                            value={feature?.name}
                            checked={feature?.isChecked}
                            onChange={(e) => {
                              handleClickCheckInput(feature?.id, "brand");
                            }}
                          />
                          <label
                            htmlFor={feature?.id}
                            style={{ marginRight: "5px" }}
                          >
                            {feature?.name}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion> */}
        {/* </div> */}
        {options.map((op) => {
          return (
            <div className="filter_accordion-box mb-4" key={op.id}>
              <Accordion className="filter_accordion">
                <Accordion.Item eventKey="1">
                  <Accordion.Header className="filter_accordion-title">
                    <div className="filter_acc-tit">
                      <span>{op.title}</span>
                      <FiChevronDown
                        size={20}
                        color="#3f4064"
                        className="filter_acc-icon"
                      />
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="filter_acc-body">
                      <div className="filter_content-acc">
                        {op.features.map((feature) => {
                          return (
                            // <div
                            //     className="filter_content-brand-select mb-4"
                            //     key={feature.id}
                            // >
                            //     <div className="brand-select-checkbox">
                            //         <div className="brand-select-check"></div>
                            //         <span>{feature.txt}</span>
                            //     </div>
                            // </div>
                            <div
                              className="filter_content-acc py-1"
                              style={{ fontSize: "initial" }}
                              key={feature.id}
                            >
                              <input
                                type="checkbox"
                                id={feature.id}
                                name={feature.txt}
                                value={feature.txt}
                                checked={feature.isChecked}
                                onChange={(e) => {
                                  handleClickCheckInput(feature.id);
                                }}
                              />
                              <label
                                htmlFor={feature.id}
                                style={{ marginRight: "5px" }}
                              >
                                {feature.txt}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          );
        })}

        <div className="filter-content-price mb-4">
          <Accordion className="filter_accordion">
            <Accordion.Item eventKey="1">
              <Accordion.Header className="filter_accordion-title">
                <div className="filter_acc-tit">
                  <span>محدوده قیمت</span>
                  <FiChevronDown
                    size={20}
                    color="#3f4064"
                    className="filter_acc-icon"
                  />
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div
                  className="filter_acc-body"
                  style={{ margin: "25px 0px", marginLeft: "15px" }}
                >
                  {/* <div className="filter-price-range mt-3 mb-2">
                    <span>از</span>
                    <input
                      type="number"
                      defaultValue=""
                      value={minPriceValue}
                      onChange={(e) => setMinPriceValue(e.target.value)}
                    />
                    <span>تومان</span>
                  </div>
                  <div className="filter-price-range mt-3 mb-2">
                    <span>تا</span>
                    <input
                      type="number"
                      defaultValue=""
                      value={maxPriceValue}
                      onChange={(e) => setMaxPriceValue(e.target.value)}
                    />
                    <span>تومان</span>
                  </div> */}
                  <InputRange
                    formatLabel={(value) => `${addCommas(value)} تومان`}
                    maxValue={maxPriceValue}
                    minValue={minPriceValue}
                    value={priceValue}
                    onChange={(value) => setPriceValue(value)}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
        <div className="filter-content-availbale mb-4">
          <span>فقط کالا های موجود</span>
          <Form>
            <Form.Check
              type="switch"
              id="custom-switch"
              checked={availableProduct}
              onClick={(e) => setAvailableProduct((prev) => !prev)}
            />
          </Form>
        </div>
        <div className="filter-content-availbale mb-4">
          <span>فقط تخفیف دارها </span>
          <Form>
            <Form.Check
              type="switch"
              id="custom-switch"
              checked={hasDiscountedProduct}
              onClick={(e) => setHasDiscountedProduct((prev) => !prev)}
            />
          </Form>
        </div>
        <div className="btn btn-light" onClick={(e) => submitFilters()}>
          اعمال
        </div>
      </div>
    </div>
  );
};

export default FilterCart;
